import styled from "styled-components";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";
import { media } from "../../../../layouts/utils";

export const Wrapper = styled.div`
  ${media.phone`
    height: 440px;
  `}
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 300px;
`;

export const Container = styled.div`
  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
  display: flex;
  width: 75%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  ${media.phone`
		display: flex;
		position: relative;
	`}
`;

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  ${media.desktop`
    align-items: center;
    justify-content: center;

  `}
  ${media.phone`
		align-items: center;
		justify-content: center;
	`}
	.botaoTagVeloe {
    margin-top: 40px;
    ${media.phone`
			position: absolute;
			top: 280px;

 	 	`}
  }
`;

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
    max-width: 250px;
    line-height: 28px;
    margin-top: 20px;
  `}
  padding: 0;
  padding-bottom: 10px;
  text-align: left;
  line-height: 45px;
  color: ${(props) => props.color};
  ${media.phone`
	  position: absolute;
    margin-top: 40px;
	  top: 0;
    text-align: center;
    font-size: 24px;
	  line-height: 36px;
	  max-width: 280px;
  `}
`;

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  padding: 0;
  text-align: left;
  max-width: 550px;
`;

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 100%;
    max-width: 380px;
    height: auto;
    margin-top: 7px;
  `}
  width: 100%;
  max-width: 450px;
  padding: 0 100px 40px 40px;

  ${media.phone`
		position: absolute;
    padding: 40px 80px 40px;
		top: 180px;
  `}
`;
